import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Save, Trash2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { toast } from 'sonner';
import { API } from '../App';

/** Admin form: set the single 'Story of the Week' on the homepage. */
export default function FeaturedStoryAdmin() {
  const [form, setForm] = useState({ title: '', caption: '', video_url: '', image_url: '', linked_product_id: '', linked_url: '', is_active: true });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/featured-story`).then((r) => {
      if (r.data && r.data.title) setForm({ ...form, ...r.data });
    }).finally(() => setLoading(false));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) { toast.error('Title is required'); return; }
    try { await axios.put(`${API}/admin/featured-story`, form); toast.success('Featured story saved'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); }
  };
  const clear = async () => {
    if (!window.confirm('Clear the featured story from the homepage?')) return;
    try {
      await axios.delete(`${API}/admin/featured-story`);
      setForm({ title: '', caption: '', video_url: '', image_url: '', linked_product_id: '', linked_url: '', is_active: true });
      toast.success('Cleared');
    } catch { toast.error('Could not clear'); }
  };

  return (
    <div className="space-y-6" data-testid="featured-story-admin">
      <div>
        <h2 className="text-2xl font-heading font-medium">Featured Story</h2>
        <p className="text-sm text-muted-foreground mt-1">One real spotlight on the homepage. Add a YouTube link OR image. Leave empty to hide.</p>
      </div>
      <Card>
        <CardHeader><CardTitle className="text-lg">Edit Story</CardTitle></CardHeader>
        <CardContent>
          {loading ? <p className="text-sm text-muted-foreground">Loading…</p> : (
            <form onSubmit={save} className="space-y-3">
              <Input placeholder="Title (e.g. 'Sarah opens her Christ Kingdom order')" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required data-testid="story-title" />
              <Textarea placeholder="Caption / story (1-2 sentences)" value={form.caption} onChange={(e) => setForm({ ...form, caption: e.target.value })} rows={3} data-testid="story-caption" />
              <Input placeholder="YouTube video URL (recommended)" value={form.video_url} onChange={(e) => setForm({ ...form, video_url: e.target.value })} data-testid="story-video" />
              <Input placeholder="OR image URL (used when no video)" value={form.image_url} onChange={(e) => setForm({ ...form, image_url: e.target.value })} data-testid="story-image" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <Input placeholder="Linked product ID (optional)" value={form.linked_product_id} onChange={(e) => setForm({ ...form, linked_product_id: e.target.value })} data-testid="story-product" />
                <Input placeholder="OR linked URL (optional)" value={form.linked_url} onChange={(e) => setForm({ ...form, linked_url: e.target.value })} data-testid="story-url" />
              </div>
              <label className="flex items-center gap-2 text-sm text-muted-foreground">
                <input type="checkbox" checked={!!form.is_active} onChange={(e) => setForm({ ...form, is_active: e.target.checked })} />
                Show on homepage
              </label>
              <div className="flex items-center gap-3">
                <Button type="submit" data-testid="story-save"><Save className="h-4 w-4 mr-2" /> Save</Button>
                <Button type="button" variant="destructive" onClick={clear} data-testid="story-clear"><Trash2 className="h-4 w-4 mr-2" /> Clear</Button>
              </div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
